export default {
    module: {
        main_menu: 'Main menu',
        categories: 'Categories'
    }
}
